import { getGlobalHeadersAsObject } from "../global-headers";
import type { DRFListResponseWrapper } from "../types";

/** A reusable document that can accompany outgoing candidate messages
 *  (email, LinkedIn message, InMail). Scoped to an assignment, a company,
 *  or neither (personal upload). */
export interface MessageDocument {
	id: number;
	created: string;
	name: string;
	content_type: string;
	size: number;
	assignment: number | null;
	company: number | null;
	uploaded_by: number;
}

export const getMessageDocuments = (
	assignmentId?: number | null
): Promise<DRFListResponseWrapper<MessageDocument[]>> => {
	const query = assignmentId != null ? `?for_assignment=${assignmentId}` : "";
	return fetch(`/api/v2/message_document/${query}`, {
		method: "GET",
		headers: getGlobalHeadersAsObject(),
	}).then((res) => res.json());
};

export const uploadMessageDocument = (
	file: File,
	assignmentId?: number | null
): Promise<MessageDocument> => {
	const formData = new FormData();
	formData.append("file", file);
	formData.append("name", file.name);
	if (assignmentId != null) {
		formData.append("assignment", String(assignmentId));
	}
	return fetch(`/api/v2/message_document/`, {
		method: "POST",
		headers: getGlobalHeadersAsObject(),
		body: formData,
	}).then(async (res) => {
		if (!res.ok) {
			const body = (await res.json()) as { detail?: string };
			throw new Error(body.detail ?? "Failed to upload document");
		}
		return res.json();
	});
};

export const deleteMessageDocument = (documentId: number): Promise<void> => {
	return fetch(`/api/v2/message_document/${documentId}/`, {
		method: "DELETE",
		headers: getGlobalHeadersAsObject(),
	}).then((res) => {
		if (!res.ok) {
			throw new Error("Failed to delete document");
		}
	});
};

export const messageDocumentDownloadUrl = (documentId: number): string =>
	`/api/v2/message_document/${documentId}/download/`;
